import { createContext, useContext, useState } from "react";

const DumpContext = createContext();

export const useDump = () => useContext(DumpContext);

export const DumpProvider = ({ children }) => {
  const [selectedTables, setSelectedTables] = useState([]);
  const [allTables, setAllTables] = useState([]);
  const [schedulerTasks, setSchedulerTasks] = useState([]);
  const [dumps, setDumps] = useState([]);

  return (
    <DumpContext.Provider value={{
      selectedTables, setSelectedTables,
      allTables, setAllTables,
      schedulerTasks, setSchedulerTasks,
      dumps, setDumps
    }}>
      {children}
    </DumpContext.Provider>
  );
};
